import { Component, OnInit } from '@angular/core';
import * as crypto from 'crypto-js';
import { EnvironmentService } from '../../../services/environment.service';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute } from '@angular/router';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'page-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginPage implements OnInit {
  public loginUrl: string | undefined;
  public rxLoginUrl: string | undefined;
  public state: string | undefined;
  public challenge: string | undefined;
  public appLogo: string;
  public loginServices: string[];
  public loginLogo: string;
  public loginHeading: string;
  public logoSize: string;
  public vhdLogoType: string;

  constructor(
    private environmentService: EnvironmentService,
    private cookieService: CookieService,
    private route: ActivatedRoute,
    private titleService: Title,
  ) {
    const title = 'Digital Practice | Login';
    this.titleService.setTitle(title);

    this.appLogo = this.environmentService.get('appWideLogo');
    this.loginServices = this.environmentService.get('login.services');
    this.loginLogo = this.environmentService.get('login.logo');
    this.loginHeading = this.environmentService.get('login.heading');
    this.logoSize = this.environmentService.get('login.logoSize');
    this.vhdLogoType = this.environmentService.get('login.vhdLogoType');
  }

  ngOnInit(): void {
    this.setupState();
    this.setupVerifier();
    this.storeReturnUrl();
  }

  openLoginWindow(service: string): void {
    switch (service) {
      case 'rx':
        window.location.href = this.buildRxLoginUrl();
        break;

      default:
        window.location.href = this.buildLoginUrl();
        break;
    }
  }

  buildLoginUrl(): string {
    return this.environmentService.get('authUrl') +
      '/oauth/authorize?client_id=' +
      this.environmentService.get('authClientId') +
      '&redirect_uri=' +
      this.environmentService.get('appUrl') +
      '/auth/callback&response_type=code&scope=*&state=' +
      this.state +
      '&code_challenge=' +
      this.challenge +
      '&code_challenge_method=S256';
  }

  buildRxLoginUrl(): string {
    return this.environmentService.get('authUrl') +
    '/rx-login?client_id=' +
    this.environmentService.get('authClientId') +
    '&redirect_uri=' +
    this.environmentService.get('appUrl') +
    '/auth/callback&response_type=code&scope=*&state=' +
    this.state +
    '&code_challenge=' +
    this.challenge +
    '&code_challenge_method=S256';
  }

  setupState(): void {
    this.state = this.createRandomString(40);
    window.localStorage.setItem('state', this.state);
  }

  setupVerifier(): void {
    const verifier = this.createRandomString(128);
    this.challenge = this.createChallenge(verifier);

    window.localStorage.setItem('verifier', verifier);
  }

  createRandomString(num: number): string {
    return [...Array(num)].map(() => Math.random().toString(36)[2]).join('');
  }

  createChallenge(str: string): string {
    return crypto.SHA256(str).toString(crypto.enc.Base64)
     .replace(/\+/g, '-')
     .replace(/\//g, '_')
     .replace(/=/g, '');
  }

  getJwtFromCookie(): string {
    return this.cookieService.get(this.environmentService.get('jwtPrefix') + 'JWT');
  }

  storeReturnUrl(): void {
    let returnUrl = '/day-list';
    if (this.route.snapshot.queryParams.returnUrl != '') {
      returnUrl = this.route.snapshot.queryParams.returnUrl;
    }

    window.localStorage.setItem('returnUrl', returnUrl);
  }
}
